import React from "react";
import { OwcIconButton, OwcListItem, OwcMenu } from "@one/react";
import ReactDOM from "react-dom";

const TopBannerAdminPanelEditOrDelete = ({ item, setApplication, setApplicationToDelete, openDialog }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOnEdit = () => {
    setApplication(item);
    setAnchorEl(null);
  };

  const handleOnDelete = () => {
    setApplicationToDelete(item);
    openDialog();
    setAnchorEl(null);
  };

  const moreIconItems = [
    {
      name: "Edit"
    },
    {
      name: "Delete"
    }
  ];

  const handleClose = (e) => {
    setAnchorEl(null);
  };

  const itemList = moreIconItems.map((item) => {
    return <OwcListItem onClick={item.name === "Edit" ? handleOnEdit : handleOnDelete}>{item.name}</OwcListItem>;
  });

  return (
    <>
      <OwcIconButton
        type="outlined"
        flat
        icon="more_vertical"
        onClick={handleClick}
        id={item.id}
      />
      {ReactDOM.createPortal(
        <OwcMenu
          anchor={item.id}
          visible={anchorEl}
          onClickOutside={handleClose}
        >
          {itemList}
        </OwcMenu>,
        document.body
      )}
    </>
  );
};
export default TopBannerAdminPanelEditOrDelete;
